import React from 'react';
import { Button, Table, Header, Segment, Tab, Icon, Popup } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import TableRow from '../../Admin/CreateCourse/TableRow';
import ExamStaff from './ExamStaff';
import ExamGroups from '../ExamTerms/ExamGroups';
import RegisteredStudents from './RegisteredStudents';
import ExamGrades from '../ExamTerms/ExamGrades';
import ExamStatistic from './ExamStatistic';
import CommitteeExamStaff from './CommitteeExamStaff';
import ThreeColumnTableRow from '../../Admin/CreateCourse/ThreeColumnTableRow';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { Redirect } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const fetchGradingMethods = () => axios.get('/grading-methods');
const fetchExamTypes = () => axios.get('/graded-activity-types');


export default class EditExam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gradingMethods: [],
            examTypes: [],
            groups: [],
            examType: '',
            newGroupIds: [],
            newGradingMethod: '',
            newGradedActivityType: '',
            newStaffArray: [],
            newDate: null,
            newClassroom: '',
            newComment: '',

            opt: 0,

            startDate: null,
            endDate: null,

            edit: false,
            back: false
        };

        this.onChange = this.onChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.editExam = this.editExam.bind(this);
        this.getName = this.getName.bind(this);
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');

        this.fetchAll(localStorage.getItem('courseImplementationId'));


        axios.get('/group-types')
            .then(res => {
                const groupType = res.data.find(e => e._key === 'exam').id;
                let obj = {};
                axios.post(`course/groups/${localStorage.getItem('courseImplementationId')}/${groupType}`, { ...obj })
                    .then(res => {
                        this.setState({
                            groups: res.data.map(el => ({
                                text: el.name, value: el.id, key: el.id
                            }))
                        });
                    })
                    .catch(err => {
                        console.log('Failed to fetch groups');
                    });
            })
            .catch(err => {
                console.log('Failed to fetch group types');
            });
    }


    fetchAll(id) {
        axios.all([fetchGradingMethods(), fetchExamTypes()])
            .then(axios.spread((gradingMethodRes, examTypeRes) => {
                const gradingMethods = gradingMethodRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));
                const examTypes = examTypeRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));

                this.setState({ gradingMethods, examTypes });
            }))
            .catch(err => {
                console.log('Failed to fetch data...');
            });
    }


    handleDateChange(name, date) {
        this.setState({ edit: true });
        if (date < localStorage.getItem('gradedActivityRegistrationDateStart') || date > localStorage.getItem('gradedActivityRegistrationDateEnd')) {
            toast('Datum ispita mora biti unutar ispitnog roka.');
            return;
        }
        this.setState({ newDate: date });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'gradedActivityName') { this.setState({ newGradedActivityType: value }); }
        if (name === 'gradingMethod') { this.setState({ newGradingMethod: value }); }
    }


    editExam() {
        let editedExam = { optLock: parseInt(localStorage.getItem('optLock'), 10) + this.state.opt, examId: localStorage.getItem('gradedActivityId') };

        if (this.state.newClassroom) editedExam = { ...editedExam, classroom: this.state.newClassroom };
        if (this.state.newDate) editedExam = { ...editedExam, examDate: moment(this.state.newDate).format() };
        if (this.state.newGradingMethod) editedExam = { ...editedExam, gradingMethodKey: this.state.gradingMethods.find(el => el.id === this.state.newGradingMethod)._key };
        if (this.state.newGradedActivityType) editedExam = { ...editedExam, gradedActivityTypeKey: this.state.examTypes.find(el => el.id === this.state.newGradedActivityType)._key };
        if (this.state.newComment) editedExam = { ...editedExam, comment: this.state.newComment };

        axios.put('/exams/update', { ...editedExam })
            .then(res => {
                toast('Izmjena ispita je uspješno izvršena.');
                this.setState({ opt: this.state.opt + 1 });
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena ispita nije uspjela.');
            });
    }

    onChange(keyName, value) {
        if (keyName === 'classroom') { this.setState({ newClassroom: value }); }
        if (keyName === 'comment') { this.setState({ newComment: value }); }
    }

    getName(id) {
        const { gradingMethods } = this.state;
        const selected = gradingMethods.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    }


    render() {
        const panes = [
            {
                menuItem: 'Podaci o ispitu',
                render: () => (<Tab.Pane>
                    <div>{(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') ? <Table celled unstackable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="left" style={{ fontSize: '17px' }}>
                                    Trenutni podaci
                                </Table.HeaderCell>
                                <Table.HeaderCell style={{ fontSize: '17px' }}>
                                    Novi podaci
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <TableRow
                                name="Datum i vrijeme ispita"
                                keyName="date"
                                value={moment(parseInt(localStorage.getItem('gradedActivityDate'), 10)).format('D. M. YYYY. - HH:mm')}
                                handleDateChange={this.handleDateChange.bind(null, 'newDate')}
                                defValue={parseInt(localStorage.getItem('gradedActivityDate'), 10)}
                            />
                            <TableRow
                                name="Prostorija"
                                keyName="classroom"
                                value={localStorage.getItem('classroom')}
                                onChange={this.onChange}
                                defValue={localStorage.getItem('classroom')}
                            />
                            {localStorage.getItem('gradedActivityName') !== 'komisijski ispit' && <TableRow
                                name="Tip ispita"
                                keyName="gradedActivityName"
                                value={localStorage.getItem('gradedActivityName')}
                                onChange={this.handleInputChange}
                                options={this.state.examTypes}
                                defValue={parseInt(localStorage.getItem('gradedActivityTypeId'), 10)}
                            />}
                            <TableRow
                                name="Način ocjenjivanja"
                                keyName="gradingMethod"
                                value={this.getName(parseInt(localStorage.getItem('gradingMethodId'), 10))}
                                onChange={this.handleInputChange}
                                options={this.state.gradingMethods}
                                defValue={parseInt(localStorage.getItem('gradingMethodId'), 10)}
                            />
                            <TableRow
                                name="Napomena"
                                keyName="comment"
                                value={localStorage.getItem('comment')}
                                onChange={this.onChange}
                                defValue={localStorage.getItem('comment')}
                            />

                        </Table.Body>
                    </Table> :
                        <Table celled unstackable compact >
                        <Table.Header>
                                <Table.Row>
                                <Table.HeaderCell>
                                    </Table.HeaderCell>
                                <Table.HeaderCell textAlign="left" style={{ fontSize: '17px' }}>
                                        Trenutni podaci
                                    </Table.HeaderCell>
                            </Table.Row>
                            </Table.Header>
                        <Table.Body>
                                {/* <TableRow */}
                                {/*    name="Datum i vrijeme ispita" */}
                                {/*    keyName="date" */}
                                {/*    value={moment(parseInt(localStorage.getItem('gradedActivityDate'), 10)).format('D. M. YYYY. - HH:mm')} */}
                                {/*    handleDateChange={this.handleDateChange.bind(null, 'newDate')} */}
                                {/*    defValue={parseInt(localStorage.getItem('gradedActivityDate'), 10)} */}
                                {/* /> */}
                                <ThreeColumnTableRow
                                    name="Datum i vrijeme ispita"
                                    keyName="date"
                                    value={moment(parseInt(localStorage.getItem('gradedActivityDate'), 10)).format('D. M. YYYY. - HH:mm')}
                                    defValue={parseInt(localStorage.getItem('gradedActivityDate'), 10)}
                            />
                                <ThreeColumnTableRow
                                    name="Prostorija"
                                    keyName="classroom"
                                    value={localStorage.getItem('classroom')}
                                    defValue={localStorage.getItem('classroom')}
                            />
                                {localStorage.getItem('gradedActivityName') !== 'komisijski ispit' && <ThreeColumnTableRow
                                    name="Tip ispita"
                                    keyName="gradedActivityName"
                                    value={localStorage.getItem('gradedActivityName')}
                                    defValue={parseInt(localStorage.getItem('gradedActivityTypeId'), 10)}
                            />}
                                <ThreeColumnTableRow
                                    name="Način ocjenjivanja"
                                    keyName="gradingMethod"
                                    value={this.getName(parseInt(localStorage.getItem('gradingMethodId'), 10))}
                                    defValue={parseInt(localStorage.getItem('gradingMethodId'), 10)}
                            />
                                <ThreeColumnTableRow
                                    name="Napomena"
                                    keyName="comment"
                                    value={localStorage.getItem('comment')}
                                    defValue={localStorage.getItem('comment')}
                            />

                            </Table.Body>
                    </Table>}
                        {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Button
                        floated="right"
                        color="blue"
                        basic="true"
                        disabled={localStorage.getItem('finalized')}
                        onClick={() => window.history.go(-1)}
                    >
                        Odustani
                    </Button>}
                        {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Button
                        floated="right"
                        color="blue"
                        disabled={localStorage.getItem('finalized')}
                        onClick={this.editExam}
                    >
                        Sačuvaj izmjene
                    </Button>}</div>
                </Tab.Pane>)
            },
            {
                menuItem: localStorage.getItem('gradedActivityName') === 'komisijski ispit' ? 'Komisija' : 'Nastavno osoblje',
                render: () => (<Tab.Pane>
                    {localStorage.getItem('gradedActivityName') === 'komisijski ispit' ?
                        <CommitteeExamStaff
                            gradedActivityId={localStorage.getItem('gradedActivityId')}
                            courseImplementationId={localStorage.getItem('courseImplementationId')}
                        />
                        : <ExamStaff
                            gradedActivityId={localStorage.getItem('gradedActivityId')}
                            courseImplementationId={localStorage.getItem('courseImplementationId')}
                        />}
                </Tab.Pane>)
            },
            localStorage.getItem('gradedActivityName') !== 'komisijski ispit' && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && {
                menuItem: 'Ispitne grupe',
                render: () => (<Tab.Pane>
                    <ExamGroups />

                </Tab.Pane>)
            },
            (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') &&
            {
                menuItem: localStorage.getItem('gradedActivityName') === 'komisijski ispit' ? 'Student' : 'Prijavljeni studenti',
                render: () => (<Tab.Pane>
                    <RegisteredStudents studentService profMozilla />

                </Tab.Pane>)
            },
            localStorage.getItem('grades') && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && {
                menuItem: localStorage.getItem('gradedActivityName') === 'komisijski ispit' ? 'Ocjena' : 'Ocjene',
                render: () => (<Tab.Pane>
                    <ExamGrades />

                </Tab.Pane>)
            },
            (localStorage.getItem('grades') && localStorage.getItem('gradedActivityName') !== 'komisijski ispit') && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && {
                menuItem: 'Statistika',
                render: () => (<Tab.Pane>
                    <ExamStatistic
                        gradedActivityId={localStorage.getItem('gradedActivityId')}
                    />

                </Tab.Pane>)
            }
        ];
        if (this.state.back) return <Redirect push to={{ pathname: '/kreiranje-i-prikaz-ispita-po-predmetima' }} />;

        return (
            <div>
                <Header as="h1">Detalji ispita</Header>
                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            <Header.Content>
                                {localStorage.getItem('courseImplementationName')} / {localStorage.getItem('gradedActivityName')} / {moment(parseInt(localStorage.getItem('gradedActivityDate'), 10)).format('D. M. YYYY. - HH:mm')}
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        // onClick={() => { localStorage.setItem('returned', true); this.setState({back: true}) }}
                                        onClick={() => { window.history.go(-1); }}
                                    />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader floated="left">
                                {(localStorage.getItem('courseComment')) === 'null' ? 'Naziv predmeta / tip ispita / datum' : localStorage.getItem('courseComment')}
                            </Header.Subheader>
                            {/* <Header.Subheader>Naziv predmeta / tip ispita / datum</Header.Subheader> */}
                        </Header>
                    </Segment>
                    <Segment clearing >
                        <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />
                    </Segment>
                    <ToastContainer hideProgressBar />

                </Segment.Group >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/EditExam.js